import {
  Button,
  Col,
  Input,
  Row,
  Select,
  Form,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { Header } from "../../components/Header";
import { toGetCurrencies, toSaveCurrency } from "../../utils/APIs";
const { Option } = Select;

const GeneralCountry = ({ showHeader, setSelectedChoice }) => {
  const [form] = Form.useForm();
  const location = useLocation();
  const [country, setCountry] = useState(location.state.country);
  const [currency, setSelectedCurrency] = useState(-1);
  const [currencyValue, setCurrencyValue] = useState(0);
  const [currencyError, setCuurencyError] = useState(false);
  const [list, setList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    toGetCurrencies(country.id).then((res) => {
      if (res.length > 0) {
        form.setFieldsValue({
          currency: res[0].currencyId,
        });
        setList(res);
      } else {
        form.setFieldsValue({
          currency: "usd",
        });
      }
    });
  }, []);

  const onChangeCurrency = (e) => {
    setSelectedCurrency(e);
    var index = list.findIndex((x) => x.currencyId == e);
    if (index != -1) {
      setCurrencyValue(list[index].currencyValue);
    } else {
      setCurrencyValue(0);
    }
  };

  const save = () => {
    if (currency == -1) {
      setCuurencyError(true);
      return;
    }
    toSaveCurrency(country.id, currency).then(() => {
      navigate("/admin");
    });
  };
  return (
    <>
      <Header />

      <div style={{ textAlign: "center", marginTop: "10vh" }}>
        <Typography.Title level={2} className="roi--title-admin">
          {country.name + " - "} <FormattedMessage id="general" />
        </Typography.Title>
      </div>

      <div
        className="roi--background-section"
        style={{ marginTop: "5vh", paddingBottom: "2vh" }}
      >
        <Row style={{ marginLeft: "2vh" }}>
          <span className="roi--label-section" style={{ marginTop: "2vh" }}>
            <FormattedMessage id="in" />
            {' "' + country.name + '",'}
          </span>
        </Row>
        <Form form={form}>
          <Row>
            <Col
              span={17}
              style={{ marginTop: "2vh", marginLeft: "2vh", marginTop: "2vh" }}
            >
              <h2 className="roi--label-section roi--line-after">
                <FormattedMessage id="currencyIs" />
              </h2>
            </Col>

            <Col span={6} style={{ marginTop: "1vh" }}>
              <Form.Item name="currency">
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  className={"roi--select-currency"}
                  onChange={(e) => {
                    onChangeCurrency(e);
                  }}
                >
                  <Option className="roi--option-currency" value="usd">
                    <FormattedMessage id="usd" />
                  </Option>
                  <Option className="roi--option-currency" value="aud">
                    <FormattedMessage id="aud" />
                  </Option>
                  <Option className="roi--option-currency" value="euro">
                    <FormattedMessage id="euro" />
                  </Option>
                  <Option className="roi--option-currency" value="gbp">
                    <FormattedMessage id="gbp" />
                  </Option>
                  <Option className="roi--option-currency" value="hkd">
                    <FormattedMessage id="hkd" />
                  </Option>
                  <Option className="roi--option-currency" value="nzd">
                    <FormattedMessage id="nzd" />
                  </Option>
                  <Option className="roi--option-currency" value="sgd">
                    <FormattedMessage id="sgd" />
                  </Option>
                  <Option className="roi--option-currency" value="thb">
                    <FormattedMessage id="thb" />
                  </Option>
                  <Option className="roi--option-currency" value="twd">
                    <FormattedMessage id="twd" />
                  </Option>
                  <Option className="roi--option-currency" value="yen">
                    <FormattedMessage id="yen" />
                  </Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>

      <div style={{ textAlign: "center" }}>
        <Button
          className="roi--button-primary"
          style={{ marginTop: "4vh", textAlign: "center", marginBottom: "2vh" }}
          onClick={() => save()}
        >
          <FormattedMessage id="save" />
        </Button>
      </div>
    </>
  );
};

export default GeneralCountry;
